<main @fade>
  <div [nbSpinner]="loading" [style.height]="loading ? '100%' : 'inherit'">
    <ng-container>
      <div class="productPopup__header">
        <h2 i18n="@@ReplaceProductByAnalog">Замена товара аналогом</h2>
      </div>
      <div class="productPopup__bottom">
        <app-customer-product-list [productList]="productList" [shortView]="true" [select]="true" [pagination]="pagination" [customCartTpl]="cartTpl"/>
      </div>
    </ng-container>
  </div>
</main>

<ng-template #cartTpl let-row="row" let-rowIndex="rowIndex">
  <button *ngIf="rowIndex === 0" nbButton status="basic" size="small" (click)="back()">Оставить</button>
  <button *ngIf="rowIndex !== 0" nbButton status="primary" size="small" (click)="select(row)">Выбрать</button>
</ng-template>
